
angular
.module('index')

	// Map view controller
	.controller('EventBulkConfirmController', function(Classes, ApiRootUrl, $state, $stateParams, MetaService) {

				
        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.registrationConfirmInProcess = false;
		self.registrationConfirmInfo = [];
		self.errorMessage = null;
		self.response = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.confirmRegistration = function(){
			self.registrationConfirmInProcess = true;
			Classes.EventRegistration.registration_confirm({
				hash: self.hash
			})
			.then(function(resp){
				self.registrationConfirmInProcess = false;
				self.registrationConfirmInfo = resp.info;
				self.response = resp;
			}).catch(function(e){
				self.registrationConfirmInProcess = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.confirmRegistration();
		
		this.goMainPage = function(){
			$state.go('index', {});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;
